<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="title()"
      [headerIcon]="iconPosition() === 'header' && !headerIconSrc() && icon() !== 'warning' ? 'error' : undefined"
      [headerIconClass]="iconPosition() === 'header' ? iconColorClass() : undefined"
      [headerIconColor]="iconPosition() === 'header' ? iconColorValue() : undefined"
      [showCloseButton]="showCloseButton()"
      [closeOnBackdropClick]="false"
      (closeModal)="onClose()"
    >
      @if (headerIconSrc()) {
        <ld-svg-icon modal-header-prefix class="w-7 h-7 shrink-0" [src]="headerIconSrc()!" />
      } @else if (iconPosition() === 'header' && icon() === 'warning') {
        <img modal-header-prefix [src]="heroiconsWarning" alt="Warning" class="w-8 h-8 shrink-0" />
      }
      <div modal-content>
        @if (iconPosition() === 'body') {
          <div class="flex justify-center mb-4">
            <div class="w-16 h-16 rounded-full flex items-center justify-center">
              <img
                [src]="icon() === 'warning' ? alertIcon : errorIcon"
                [alt]="icon() === 'warning' ? 'Warning' : 'Error'"
                class="w-8 h-8"
              />
            </div>
          </div>
        }

        <div
          [class.p-6]="iconPosition() === 'body'"
          [class.pt-2]="iconPosition() === 'header'"
          [class.text-left]="iconPosition() === 'header'"
        >
          <p id="error-modal-message" class="text-ld-neutral-500 mb-6" [class.text-center]="iconPosition() === 'body'">
            {{ message() }}
          </p>

          @if (showSupportContact()) {
            <div class="bg-ld-neutral-50 border border-ld-neutral-200 rounded-lg p-4 mb-6">
              <div class="flex items-start gap-3">
                <mat-icon class="text-ld-neutral-400 text-[20px]! w-5! h-5! shrink-0 mt-0.5">support_agent</mat-icon>
                <div>
                  <p id="error-modal-help-label" class="text-sm text-ld-neutral-600 font-medium mb-1">
                    {{ t('modalsErrorNeedHelp') }}
                  </p>
                  <p id="error-modal-help-text" class="text-sm text-ld-neutral-500">
                    {{ t('modalsErrorContactSupport') }}
                    <a
                      id="error-modal-phone-link"
                      [href]="'tel:' + supportPhoneTel()"
                      class="font-semibold text-ld-primary hover:underline cursor-pointer"
                    >
                      {{ supportPhone() }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div modal-footer>
        @if (hasSecondaryButton()) {
          <button
            id="error-modal-secondary-btn"
            type="button"
            class="btn-outline-ld-purple"
            (click)="onSecondaryClick()"
          >
            {{ secondaryBtnText() }}
          </button>
        }
        @if (hasSecondaryButton()) {
          <button id="error-modal-primary-btn" type="button" [class]="primaryBtnClass()" (click)="onPrimaryClick()">
            {{ primaryBtnText() }}
          </button>
        } @else {
          <div
            class="flex w-full"
            [class.justify-end]="iconPosition() === 'header'"
            [class.justify-center]="iconPosition() === 'body'"
          >
            <button id="error-modal-primary-btn" type="button" [class]="primaryBtnClass()" (click)="onPrimaryClick()">
              {{ primaryBtnText() }}
            </button>
          </div>
        }
      </div>
    </ld-base-modal>
  }
</ng-container>
